"use client";

import { Pagination } from "@heroui/react";
import { useTranslations } from "next-intl";
import PageLayout from "../layout/PageLayout";
import { TournamentGrid } from "../tournament";
import { TournamentWithDetails } from "../tournament/TournamentGrid";

interface ArchivePageClientProps {
  tournaments: TournamentWithDetails[];
  searchParams?: { [key: string]: string | string[] | undefined };
}

const TOURNAMENTS_PER_PAGE = 12;

export default function ArchivePageClient({
  tournaments,
  searchParams,
}: ArchivePageClientProps) {
  const t = useTranslations();

  const currentPage = Number(searchParams?.page) || 1;
  const totalPages = Math.ceil(tournaments.length / TOURNAMENTS_PER_PAGE);
  const startIndex = (currentPage - 1) * TOURNAMENTS_PER_PAGE;
  const currentTournaments = tournaments.slice(
    startIndex,
    startIndex + TOURNAMENTS_PER_PAGE,
  );

  return (
    <PageLayout
      pageHeaderProps={{
        pretitle: t("tournaments.archivePage.pretitle"),
        title: t("tournaments.archivePage.title"),
        description: t("tournaments.archivePage.description"),
      }}
    >
      <TournamentGrid
        tournaments={currentTournaments}
        activeOnly={false}
        emptyMessage={t("tournaments.archivePage.empty")}
      />
      {totalPages > 1 && (
        <div className="mt-8 flex justify-center">
          <Pagination total={totalPages} page={currentPage} />
        </div>
      )}
    </PageLayout>
  );
}
